export default __webpack_public_path__ + "static/xr_glasses_m-df15e9243a235b5ee5497cdbc3c6dfb9.png";